export const PREFIX = "$";
